import React, { FC, memo } from 'react';
import { StyleProps } from 'src/lib/styleProps';
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { Button, ButtonWithLoader } from 'src/common/components/Button';
import { useCourseBundleSignInMutation } from 'src/common/hooks/courseBundle/useCourseBundleSignInMutation';
import { authActions } from 'src/state/auth/authActions';
import { pageContextActions } from 'src/state/pageContext/pageContextActions';
import { PostRedirectAction } from 'src/config/postRedirectAction';
import { LoginRoute } from 'src/public/publicRoutes';
import { useDispatch } from 'react-redux';
import { useGatsbyLikeLocation } from 'src/common/migration/useGatsbyLikeLocation';
import { useGatsbyLikeNavigate } from 'src/common/migration/useGatsbyLikeNavigate';
import { CourseBundleDTO } from 'src/common/models/courseBundle';

export const CourseBundleActions: FC<StyleProps & { courseBundle: CourseBundleDTO }> = memo(
  ({ courseBundle }) => {
    const location = useGatsbyLikeLocation();
    const navigate = useGatsbyLikeNavigate();
    const { isLoggedIn } = useIsLoggedIn();
    const dispatch = useDispatch();
    const { mutate: signInForCourseBundle } = useCourseBundleSignInMutation();

    const handleOnClick = () => {
      if (isLoggedIn) {
        signInForCourseBundle(courseBundle.id);
      } else {
        dispatch(
          authActions.setRedirectUrl({
            action: PostRedirectAction.JoinCourseBundle,
            pathname: location.pathname,
            publicRoute: true,
            query: location.query,
          }),
        );
        dispatch(
          pageContextActions.setAuthCourseExcerpt({
            image: courseBundle.image,
            title: courseBundle.title,
          }),
        );
        navigate(LoginRoute, { replace: true });
      }
    };

    return (
      <Button style={{ width: '100%' }} as={ButtonWithLoader} onClick={handleOnClick}>
        Zapisz się bezpłatnie
      </Button>
    );
  },
);

CourseBundleActions.displayName = 'CourseBundleActions';
